module.exports = __webpack_public_path__ + "img/mint_success.f72013ac.png";